
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { FgiBackEndService } from '../fgi-back-end.service';
import { Observable } from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ProtocoloArquivo, StatusProtocolo } from 'src/app/model/protocolo-arquivo.model';
import { Arquivo, TipoConteudo } from 'src/app/model/arquivo.model';
import { ResultadoPaginado } from 'src/app/model/resultado';
import { SolicitacaoHonraEnvio } from 'src/app/model/solicitacao-honra.model';
import { MensagemRetornoAssincrono } from 'src/app/model/mensagem-retorno-assincrono.model';

@Injectable({
    providedIn: 'root'
})
export class ProtocoloArquivoService extends FgiBackEndService<any> {

    // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
    getNewEntity() {
        return new ProtocoloArquivo();
    }

    // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
    protected getResourceURL(): string {
        return 'front/protocolos-arquivos';
    }

    public enviarArquivo(arquivo: Arquivo, tipoConteudo: TipoConteudo, apenasValidar: boolean, individual?: boolean): Observable<MensagemRetornoAssincrono> {
        const options: any = blockUi();
        options.params.apenasValidacao = apenasValidar;
        options.params.individual = individual;

        const url = `${this.BASE_URL}/${tipoConteudo}`;

        return this.http.post(url, arquivo.value, options).pipe(
            catchError((e) => this.handleError(e))) as Observable<MensagemRetornoAssincrono>;
    }

      
    public enviarSHIndividual (operacao: string, idProtocoloNegocio: string, shId?: number, sh?: SolicitacaoHonraEnvio, shPrioridade?: number ): Observable<String> {
        
        console.log("enviarSHIndividual", operacao);

        // na inclusão, 'operacao' é vazia. Senão, vem com 'atualiza' ou 'exclui'
        const url = `${this.BASE_URL}/${TipoConteudo.SOLICITACOES_HONRA}/solicitacao-honra`
            + (shId ? `/${shId}/${operacao}` : operacao == 'exclui-todas' ? `/${operacao}` : '')
            + `?idProtocoloNegocio=${idProtocoloNegocio}` 
            + (shPrioridade ? `&prioridade=${shPrioridade-1}`: '');
        return this.http.post(url, sh).pipe(
            catchError((e) => this.handleError(e))) as Observable<String>;
    }

    public enviarRepriorizacaoSHs (idProtocoloNegocio: string, shs: SolicitacaoHonraEnvio[] ): Observable<String> {
        
        const url = `${this.BASE_URL}/${TipoConteudo.SOLICITACOES_HONRA}/solicitacao-honra/repriorizacao`
            + `?idProtocoloNegocio=${idProtocoloNegocio}` ;
        return this.http.post(url, shs, blockUi()).pipe(
            catchError((e) => this.handleError(e))) as Observable<String>;
    }

    public statusSolicitacao(idProtocoloNegocio: string): Observable<string> {
        return this.http.get(`${this.BASE_URL}/${idProtocoloNegocio}/status`).pipe(
            catchError(this.handleError)) as Observable<string>;
    }

    public getArquivoMaisRecente(params?: any, options?: any): Observable<ProtocoloArquivo> {

        const url = `${this.BASE_URL}/protocolo-mais-recente-no-periodo/`;

        return this.http.get(url, {params: params}).pipe(
            catchError(this.handleError)
        ) as Observable<ProtocoloArquivo>;
    }

    public getArquivosPorAgente(params?: any, options?: any): Observable<ResultadoPaginado<ProtocoloArquivo>> {

        const url = `${this.BASE_URL}/`;

        return this.http.get(url, {params: params}).pipe(
            catchError(this.handleError)
        ) as Observable<ResultadoPaginado<ProtocoloArquivo>>;
    }

    public getJanelaPermitirEnvio(params?: any, options?: any): Observable<boolean> {

        const url = `${this.BASE_URL}/fora-janela-permitir-envio`;

        return this.http.get<boolean>(url, {params: params}).pipe(
            catchError(this.handleError)
        );
    }

    public getArquivoEnvioCsv(idProtocoloArquivo: string): Observable<any> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/enviado/csv`;
        let options:any = blockUi();
        options.responseType = "text";
        return this.http.get(url, options).pipe(
            catchError(this.handleError)
        ) as Observable<any>;
    }

    public getArquivoEnvio(idProtocoloArquivo: string): Observable<string> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/enviado`;
        return this.http.get(url, blockUi()).pipe(
            catchError(this.handleError)
        ) as Observable<string>;
    }

    public getArquivoRespostaCsv(idProtocoloArquivo: string): Observable<any> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/resposta/csv`;
        let options:any = blockUi();
        options.responseType = "text";
        return this.http.get(url, options).pipe(
            catchError(this.handleError)
        ) as Observable<any>;
    }

    public getArquivoResposta(idProtocoloArquivo: string): Observable<string> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/resposta`;
        return this.http.get(url, blockUi()).pipe(
            catchError(this.handleError)
        ) as Observable<string>;
    }

    public excluirProtocolo(idProtocoloArquivo: string): Observable<any> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/excluir`;
        return this.http.post(url, blockUi()).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }

    public cancelarProtocolo(idProtocoloArquivo: string): Observable<any> {
        const url = `${this.BASE_URL}/${idProtocoloArquivo}/cancelar`;
        return this.http.post(url, blockUi()).pipe(
            catchError((e) => this.handleError(e))) as Observable<any>;
    }
}
